import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  beginSurveyLink,
  getIdentityFirstLoginFlow,
  getOnboardingSurveyLink,
  getIdentityStage,
} from 'store/entities/identity/selectors'
import { markLoginFlowAsFinished, requestSurvey, updateOnboardingChecklist } from 'store/entities/identity/actions'
import OnboardingBriefQuiz from 'app/domains/routes/OnBoarding/OnBoardingBriefQuiz/OnBoardingBriefQuiz'
// @ts-ignore
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { modal } from 'store/entities/modal/actions'
// @ts-ignore
import { SELECTION, DONE } from 'app/constants/stages'
import { IDispatchProps, IOwnProps, IStateProps } from './interface'
import { IS_QUIZ_COMPLETED } from 'app/constants/onBoarding'

const mapStateToProps = createStructuredSelector({
  beginSurveyLink,
  isLoginFlowFinished: getIdentityFirstLoginFlow,
  surveyLink: getOnboardingSurveyLink,
  getIdentityStage,
})

const mapDispatchToProps = {
  requestSurvey: ({ isPostSurvey, sendEmail }: any) =>
    requestSurvey({
      surveyType: isPostSurvey ? 'end' : 'begin',
      sendEmail,
    }),
  showTypeFormPopup,
  hideModal: modal.hide,
  markLoginFlowAsFinished,
  updateOnboardingChecklist,
}

const mergeProps = (
  { surveyLink, getIdentityStage, ...restState }: IStateProps,
  { showTypeFormPopup, requestSurvey, hideModal, updateOnboardingChecklist, ...restDispatch }: IDispatchProps,
  ownProps: IOwnProps
) => {
  const isPostSurvey = getIdentityStage === SELECTION || getIdentityStage === DONE

  return {
    ...restState,
    ...ownProps,
    ...restDispatch,
    requestSurvey,
    hideModal,
    isPostSurvey,
    surveyLink,
    showTypeFormPopup: () => {
      showTypeFormPopup({
        typeFormLink: surveyLink as string,
        onSubmit: () => {
          requestSurvey({ isPostSurvey, sendEmail: false })
          updateOnboardingChecklist({ propertyName: IS_QUIZ_COMPLETED, propertyValue: true })
          hideModal()
        },
      })
    },
  }
}
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OnboardingBriefQuiz)
